import { Route } from '@angular/router';
import { SecureComponent } from './secure.component';
import { authGuard } from '../../core/guards/auth.guard';
import { shellsRoutes } from './shells/shells.routes';
import { adminRoutes } from './admin/admin.routes';
import { assetTransferRoutes } from './asset-transfer/asset-transfer.routes';
import { qualityRoutes } from './quality/quality.routes';

export const secureRoutes: Route[] = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'shells/part-instances',
        pathMatch: 'full',
      },
      ...shellsRoutes,
      ...adminRoutes,
      ...assetTransferRoutes,
      ...qualityRoutes
    ],
  }
  // {
  //   path: '**',
  //   redirectTo: 'secure/dashboard',
  // },
];
